import { render, staticRenderFns } from "./TestEmailEditor.vue?vue&type=template&id=3a1b5044&"
import script from "./TestEmailEditor.vue?vue&type=script&lang=js&"
export * from "./TestEmailEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports